// extracted by mini-css-extract-plugin
export default {"groupNote":"html_groupNote__2-Ulc","iconEdit":"html_iconEdit__w5ytS"};